import { Box, Flex, Text } from "@mantine/core";
import {
  IconChevronLeft,
  IconDotsVertical,
  IconPencil,
  IconX,
} from "@tabler/icons-react";
import { ReactNode } from "react";

interface FormModalHeaderProps {
  title: ReactNode;
  isDesktop?: boolean;
  isEdit?: boolean;
  withMenu?: boolean;
  onClickMenu?: () => void;
  goBack: () => void;
  onClose?: () => void;
}

const FormModalHeader: React.FC<FormModalHeaderProps> = ({
  title,
  isDesktop = false,
  isEdit = false,
  withMenu = false,
  onClickMenu,
  goBack,
  onClose,
}) => {
  return (
    <Flex gap={"md"} justify={"space-between"}>
      <Flex
        className="border-b border-gray w-full"
        align={"center"}
        justify={"space-between"}
        p={"lg"}
        mih={56}
        bg={"white"}
        pos="relative"
        c="gray.8"
      >
        {isDesktop && onClose ? (
          <Box
            component="button"
            onClick={goBack}
            className="group/button cursor-pointer"
            aria-label="Go back"
          >
            <IconChevronLeft className="text-gray group-hover/button:text-blue" />
          </Box>
        ) : !isDesktop ? (
          <Box
            component="button"
            onClick={goBack}
            className="group/button cursor-pointer"
            aria-label="Go back"
          >
            <IconChevronLeft className="text-gray group-hover/button:text-blue" />
          </Box>
        ) : null}
        {typeof title === "string" ? (
          <Flex
            align="center"
            gap={8}
            pos={isDesktop ? "static" : "absolute"}
            style={
              !isDesktop
                ? {
                    left: 0,
                    right: 0,
                    justifyContent: "center",
                    pointerEvents: "none",
                  }
                : undefined
            }
          >
            {isDesktop && isEdit && <IconPencil className="text-black" />}
            <Text
              tt={isDesktop ? "uppercase" : "none"}
              lh={1}
              size={isDesktop ? "md" : "sm"}
              fw={600}
            >
              {title}
            </Text>
          </Flex>
        ) : (
          title
        )}

        <Flex gap={"md"} align={"center"}>
          {withMenu && (
            <button onClick={onClickMenu} className="cursor-pointer">
              <IconDotsVertical />
            </button>
          )}
          {isDesktop && (
            <Box
              component="button"
              onClick={onClose ?? goBack}
              className="group/button cursor-pointer"
              pr={5}
              aria-label="Close"
            >
              <IconX className="text-gray group-hover/button:text-blue" />
            </Box>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FormModalHeader;
